<template lang="pug">
table-base.teacher-list-table
  //- ヘッダー部
  table-row-base.teacher-list-table__row-header.text-medium
    table-header-base.teacher-list-table__row-header__cell
      .teacher-list-table__row-header__cell__checkbox(:data-selected='checkedAll')
        input.teacher-list-table__row-header__cell__checkbox__input(type='checkbox', v-model='isCheckedAll', :id='UID')
        label-base.teacher-list-table__row-header__cell__checkbox__label(:for='UID')
    table-header-base.teacher-list-table__row-header__cell.align-left
      toggle-sort.teacher-list-table__row-header__cell__toggle(
        :sortSetting='sort.userName',
        @change-sort='sortChangeEvent($event, "userName")'
      )
        slot(name='userNameHeader')
    table-header-base.teacher-list-table__row-header__cell.align-left
      toggle-sort.teacher-list-table__row-header__cell__toggle(
        :sortSetting='sort.bcbtCode',
        @change-sort='sortChangeEvent($event, "bcbtCode")'
      )
        slot(name='bcbtCodeHeader')
    table-header-base.teacher-list-table__row-header__cell.align-left(v-if='isAdmin')
      toggle-sort.teacher-list-table__row-header__cell__toggle(
        :sortSetting='sort.academyName',
        @change-sort='sortChangeEvent($event, "academyName")'
      )
        slot(name='academyNameHeader')
    table-header-base.teacher-list-table__row-header__cell.align-left(v-if='isAdminOrAcademy')
      toggle-sort.teacher-list-table__row-header__cell__toggle(
        :sortSetting='sort.branchName',
        @change-sort='sortChangeEvent($event, "branchName")'
      )
        slot(name='branchNameHeader')
    table-header-base.teacher-list-table__row-header__cell.align-left
      toggle-sort.teacher-list-table__row-header__cell__toggle(
        :sortSetting='sort.roleName',
        @change-sort='sortChangeEvent($event, "roleName")'
      )
        slot(name='roleNameHeader')
    table-header-base.teacher-list-table__row-header__cell.align-center
      slot(name='editHeader')
  template(v-for='teacherData in teacherDatas')
    //- 一覧表示部
    table-row-base.teacher-list-table__row.text-small.font-medium
      table-data-base.teacher-list-table__row__cell
        .teacher-list-table__row__cell__checkbox(:data-selected='dataSelected(teacherData.userId)')
          input.teacher-list-table__row__cell__checkbox__input(
            type='checkbox',
            :value='teacherData.userId',
            v-model='selectedValue',
            :id='getInputId(teacherData.userId)'
          )
          label-base.teacher-list-table__row__cell__checkbox__label(:for='getInputId(teacherData.userId)')
      table-data-base.teacher-list-table__row__cell
        .teacher-list-table__row__cell__text {{ teacherData.userName }}
      table-data-base.teacher-list-table__row__cell
        .teacher-list-table__row__cell__text {{ teacherData.bcbtCode }}
      table-data-base.teacher-list-table__row__cell(v-if='isAdmin')
        .teacher-list-table__row__cell__text {{ teacherData.academyName }}
      table-data-base.teacher-list-table__row__cell(v-if='isAdminOrAcademy')
        .teacher-list-table__row__cell__text {{ teacherData.branchName }}
      table-data-base.teacher-list-table__row__cell
        .teacher-list-table__row__cell__text {{ teacherData.roleName }}
      table-data-base.teacher-list-table__row__cell
        popup-edit.teacher-list-table__row__cell__popup(
          :deleteEvent='deleteEvent',
          :editEvent='editEvent',
          :editId='teacherData.userId'
        )
          template(#removeText)
            slot(name='popupRemoveText')
          template(#editText)
            slot(name='popupEditText')
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator'
import TableBase from '@/components/atoms/TableBase.vue'
import TableRowBase from '@/components/atoms/TableRowBase.vue'
import TableHeaderBase from '@/components/atoms/TableHeaderBase.vue'
import TableDataBase from '@/components/atoms/TableDataBase.vue'
import LabelBase from '@/components/atoms/LabelBase.vue'
import ToggleSort from '@/components/molecules/manager/ToggleSort.vue'
import PopupEdit from '@/components/organisms/manager/PopupEdit.vue'
import { TeacherListType, TeacherListSortType } from '@/models/teacherListModel'
import { UserRoles } from '@/const/UserRoles'

/**
 * ユーザー管理（先生・講師）一覧テーブル
 */
@Component({
  components: {
    TableBase,
    TableRowBase,
    TableHeaderBase,
    TableDataBase,
    LabelBase,
    ToggleSort,
    PopupEdit,
  },
})
export default class TeacherListTable extends Vue {
  // ユーザ権限
  @Prop()
  userRole!: UserRoles

  // 全チェックフラグ
  @Prop()
  checkedAll!: boolean

  // ヘッダーチェックボックスの変更イベント
  @Prop()
  headerCheckboxChangeEvent!: Function

  // ソート値（項目毎の昇順フラグ）
  @Prop()
  sort!: TeacherListSortType

  // ソート値変更時イベント
  @Prop()
  sortChangeEvent!: Function

  // 先生一覧情報
  @Prop()
  teacherDatas!: TeacherListType[]

  // 一覧内チェックボックスのチェックされた先生ユーザID
  @Prop()
  checkedTeacherUserIds!: number[]

  // 一覧内チェックボックスの変更イベント
  @Prop()
  checkboxChangeEvent!: Function

  // 削除イベント
  @Prop()
  deleteEvent!: Function

  // 編集イベント
  @Prop()
  editEvent!: Function

  // コンポーネント単位のユニークID取得
  private readonly UID = this.$uuid.v4()

  // inputタグの個別ID
  private getInputId(id: number): string {
    return `id${this.UID}_${id}`
  }

  // 選択状態に応じてカスタムデータ属性を付与
  private dataSelected(value: number): boolean {
    return this.checkedTeacherUserIds.includes(value)
  }

  /**
   * ヘッダーチェックボックスのゲッターセッター
   */
  get isCheckedAll(): boolean {
    return this.checkedAll
  }
  set isCheckedAll(value: boolean) {
    // チェック時は一覧内の全チェックボックスをチェック、チェック解除時は全チェックボックスをチェック解除する
    const checkedIds = value
      ? this.teacherDatas.map((teacherData) => {
          return teacherData.userId
        })
      : []
    this.checkboxChangeEvent(checkedIds)
    this.headerCheckboxChangeEvent(value)
  }

  /**
   * チェックボックス選択値のゲッターセッター
   */
  get selectedValue(): number[] {
    return this.checkedTeacherUserIds
  }
  set selectedValue(value: number[]) {
    // 全チェックボックスがチェックされていなければヘッダーのチェックボックスをチェック解除する
    if (value.length < this.teacherDatas.length) {
      this.headerCheckboxChangeEvent(false)
    }
    this.checkboxChangeEvent(value)
  }

  // システム管理者であるか
  private get isAdmin(): boolean {
    return this.userRole === UserRoles.ADMIN
  }

  // システム管理者または塾管理者であるか
  private get isAdminOrAcademy(): boolean {
    return this.userRole === UserRoles.ADMIN || this.userRole === UserRoles.ACADEMY
  }
}
</script>

<style lang="stylus" scoped>
.teacher-list-table
  width 100%

  &__row-header,
  &__row
    border-bottom 1px solid var(--color-manager-list__border)

    &__cell
      &__checkbox
        display flex
        align-items center
        justify-content center

        &__input
          display none

        &__label
          width 20px
          height 20px
          background-image url("~@/assets/img/common/checkbox/off.svg")

        &[data-selected='true'] &__label
          background-image url("~@/assets/img/common/checkbox/on.svg")


  &__row-header
    background var(--color-manager-list__background)

    &__cell
      padding 10px 20px

      &:nth-child(1)
        width 65px
      &:nth-last-child(2)
        width 215px
      &:nth-last-child(1)
        width 130px

  &__row
    background var(--color-manager-list__background)
    height 55px

    &__cell
      padding 0 20px

      &__popup
        justify-content center

    &:hover
      background var(--color-manager-list__hover)
</style>
